<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-truck-fast"></i></span>{{ "ForwarderCooperation.ForwarderHeader" | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [(selected)]="isSearchFormOpen">
        <form [formGroup]="searchForm" >
          <div class="grid formgrid p-fluid">
          <!-- 起運地位置選擇 - 只顯示國家和城市 -->
          <laas-location-cascade-dropdown
            formControlName="fromLocation"
            [showCountry]="true"
            [showCity]="true"
            [showArea]="false"
            [showExpressArea]="false"
            [showDistrict]="false"
            countryLabel="{{ 'ForwarderCooperation.SearchForm.FromCountry' | translate }}"
            cityLabel="{{ 'ForwarderCooperation.SearchForm.FromCity' | translate }}"
            countryPlaceholder="{{ 'Common.DropDown.Select' | translate }}"
            cityPlaceholder="{{ 'Common.DropDown.Select' | translate }}"
            [allowAllOption]="false"
            [showClear]="true"
            [enableFilter]="true"
            [cssClasses]="'field col-12 md:col-6'"
            [submitted]="searchValueIsValid"
            [requiredFields]="['country', 'city']"
            (countryOptionsReady)="onCountryOptionsReady($event)"
            (cityOptionsReady)="onCityOptionsReady($event)">
          </laas-location-cascade-dropdown>

          <!-- 目的地位置選擇 - 只顯示國家和城市 -->
          <laas-location-cascade-dropdown
            formControlName="toLocation"
            [showCountry]="true"
            [showCity]="true"
            [showArea]="false"
            [showExpressArea]="false"
            [showDistrict]="false"
            countryLabel="{{ 'ForwarderCooperation.SearchForm.ToCountry' | translate }}"
            cityLabel="{{ 'ForwarderCooperation.SearchForm.ToCity' | translate }}"
            countryPlaceholder="{{ 'Common.DropDown.Select' | translate }}"
            cityPlaceholder="{{ 'Common.DropDown.Select' | translate }}"
            [allowAllOption]="false"
            [showClear]="true"
            [enableFilter]="true"
            [cssClasses]="'field col-12 md:col-6'"
            [submitted]="searchValueIsValid"
            [requiredFields]="['country', 'city']">
          </laas-location-cascade-dropdown>

            <div class="field col-12 md:col-6">
              <label>{{ "ForwarderCooperation.SearchForm.ShippingType" | translate }}</label>
              <p-dropdown
              [filter]="true"
              placeholder="{{ 'Common.DropDown.Select' | translate}}"
              [options]="shippingTypeOptions"
              [showClear]="true"
              formControlName="shippingType"
            ></p-dropdown>
            </div>

            <div class="field col-12 md:col-6">
              <label>{{ "ForwarderCooperation.SearchForm.ShipTerm" | translate }}</label>
              <p-dropdown
              [filter]="true"
              placeholder="{{ 'Common.DropDown.Select' | translate}}"
              [options]="shiptermOptions"
              [showClear]="true"
              formControlName="shipTerm"
            ></p-dropdown>
            </div>
          </div>
          <div class="grid align-items-center vertical-container">
              <label class="ml-2"> {{ "ForwarderCooperation.SearchAll" | translate}} </label> <p-inputSwitch (onChange)="changeSearchMode($event)" class="mt-2 mr-2 ml-2"></p-inputSwitch>
              <button pButton pRipple label="{{ 'Common.Button.Search' | translate}}" (click)="searchBtnClick()" class="ml-2"></button>
              <button pButton label="{{ 'Common.Button.Reset' | translate}}" class="p-button-secondary ml-2" (click)="resetBtnClick()"></button>
              <button pButton label="{{ 'ForwarderCooperation.button.ShipTerm' | translate }}" class="ml-2 p-button-help" style="color: white" (click)="showForwarderDesc(true)"></button>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <laas-data-table
      [tableKey]="headerPreferenceKey"
      [value]="tableValue"
      [defaultColumns]="tableColumns"
      [loading]="isHeaderLoading"
      [selectable]="true"
      [dataKey]="'index'"
      [rows]="pageInfo.pageSize"
      [lazy]="true"
      [totalRecords]="pageInfo.totalRecords"
      (tableOnPage)="tablePageChange($event)"
      (tableOnSort)="tableSort($event)"
      #DataTableComponent
      class="hidden md:block"
      >

      <ng-template pTemplate="caption">
        <button
          pButton
          label="{{ 'ForwarderCooperation.QuotationLinkButton' | translate }}"
          class="ml-2 p-button-warning"
          style="color: white"
          (click)="goToFreightTrialCalculation()"
        ></button>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'toCity'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: allCityOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'fromCity'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: allCityOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'toCountry'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: countryOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'fromCountry'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: countryOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'shippingType'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: shippingTypeOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'forwarder'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: forwarderOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'rfqCategory'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: rfqCategoryTypeOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'facility'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: facilityOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: "-" }}
              </div>
            </ng-container>
          </ng-container>
        </td>
      </ng-template>

    </laas-data-table>

    <laas-data-view class="block md:hidden" [value]="tableValue" [paginator]="true"
      [rows]="pageInfo.pageSize" [totalRecords]="pageInfo.totalRecords" [lazy]="true" (onPage)="tablePageChange($event)" >
      <ng-template let-result pTemplate="listItem">
        <div class="field col-12">
          <div class="p-fluid grid laas-list-item">
            <ng-container *ngFor="let col of tableColumns" [ngSwitch]="col.field">
              <div class="col-12 md:col-6 lg:col-4 mb-3 md:col-3 lg:col-2 mb-0 text-right">
                <label class="font-bold mb-0">{{ col.header | translate }}</label>
              </div>

              <ng-container *ngSwitchCase="'toCity'">
                <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                  {{ result[col.field] | optionsMapping: allCityOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'fromCity'">
                <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                  {{ result[col.field] | optionsMapping: allCityOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'toCountry'">
                <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                  {{ result[col.field] | optionsMapping: countryOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'fromCountry'">
                <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                  {{ result[col.field] | optionsMapping: countryOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'shippingType'">
                <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                  {{ result[col.field] | optionsMapping: shippingTypeOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'forwarder'">
                <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                  {{ result[col.field] | optionsMapping: forwarderOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'rfqCategory'">
                <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                  {{ result[col.field] | optionsMapping: rfqCategoryTypeOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'facility'">
                <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                  {{ result[col.field] | optionsMapping: facilityOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchDefault>
                <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text" [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    {{ result[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    {{ result[col.field] | replaceNullWith:'-'}}
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>


          </div>
        </div>
      </ng-template>

      <ng-template let-result pTemplate="gridItem">
        <div class="col-12 md:col-4 lg:col-3">
          <div class="p-fluid grid laas-grid-item">
              <ng-container *ngFor="let col of tableColumns" [ngSwitch]="col.field">
                <div class="col-12 md:col-6 lg:col-4 mb-3 mb-0 text-right">
                  <label class="font-bold mb-0">{{ col.header | translate }}</label>
                </div>

                <ng-container *ngSwitchCase="'toCity'">
                  <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                    {{ result[col.field] | optionsMapping: allCityOptions | replaceNullWith: "-" }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'fromCity'">
                  <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                    {{ result[col.field] | optionsMapping: allCityOptions | replaceNullWith: "-" }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'toCountry'">
                  <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                    {{ result[col.field] | optionsMapping: countryOptions | replaceNullWith: "-" }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'fromCountry'">
                  <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                    {{ result[col.field] | optionsMapping: countryOptions | replaceNullWith: "-" }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'shippingType'">
                  <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                    {{ result[col.field] | optionsMapping: shippingTypeOptions | replaceNullWith: "-" }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'forwarder'">
                  <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                    {{ result[col.field] | optionsMapping: forwarderOptions | replaceNullWith: "-" }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'rfqCategory'">
                  <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                    {{ result[col.field] | optionsMapping: rfqCategoryTypeOptions | replaceNullWith: "-" }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'facility'">
                  <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                    {{ result[col.field] | optionsMapping: facilityOptions | replaceNullWith: "-" }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text" [ngSwitch]="col.dataType">
                    <ng-container *ngSwitchCase="'date'">
                      {{ result[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      {{ result[col.field] | replaceNullWith:'-'}}
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </div>
        </div>
      </ng-template>
    </laas-data-view>
  </p-card>

  <ng-container *ngIf="isShowDescriptionModel">
    <laas-shipterm-description
      [(visible)]="isShowDescriptionModel"
      (importClick)="importdailyRate($event)"
      (visibleChange)="dialogVisibleChange($event)"
    ></laas-shipterm-description>
  </ng-container>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
